import Cookies from "js-cookie";

export class CookieUtils {
  static get(name) {
    return Cookies.get(name);
  }

  static set(name, value, options) {
    Cookies.set(name, value, options);
  }

  static remove(name) {
    Cookies.remove(name);
  }
}
